import * as d3 from 'd3';

export function drawTilt(
  svg,
  x,
  y,
  width,
  height,
  frameWidth = 10,
  lineColor = 'red'
) {
  const xLeft = x;
  const xRight = x + width;
  const yBottom = y + height;
  const xTopMiddle = x + width / 2;
  const yTop = y;

  // Line from bottom-left to top-middle
  svg.append('line')
    .attr('x1', xLeft)
    .attr('y1', yBottom)
    .attr('x2', xTopMiddle)
    .attr('y2', yTop)
    .attr('stroke', lineColor)
    .attr('stroke-width', 1)
    .attr('stroke-dasharray', '6,4');

  // Line from bottom-right to top-middle
  svg.append('line')
    .attr('x1', xRight)
    .attr('y1', yBottom)
    .attr('x2', xTopMiddle)
    .attr('y2', yTop)
    .attr('stroke', lineColor)
    .attr('stroke-width', 1)
    .attr('stroke-dasharray', '6,4');
}
